import { render, staticRenderFns } from "./form-login.vue?vue&type=template&id=5e504af8"
import script from "./form-login.vue?vue&type=script&lang=js"
export * from "./form-login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports